import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-risk-rating',
  templateUrl: './risk-rating.component.html',
  styleUrls: ['./risk-rating.component.css']
})
export class RiskRatingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
